exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resultuStKAOS9{text-align:center}.resultuStKAOS9 .result1bELYnuD{position:relative}.resulta3lp72xk,.result2XlDhB1U{position:absolute}\n", ""]);

// exports
exports.locals = {
	"mainid": "resultuStKAOS9",
	"button": "result1bELYnuD",
	"top": "resulta3lp72xk",
	"bottom": "result2XlDhB1U"
};